module.exports = __webpack_public_path__ + "img/02shequ.a7f80568.png";